<template>
  <input
    type="text"
    ref="autocomplete"
    v-model="autocompleteValue"
    :id="id"
    :class="className"
    :placeholder="placeholder"
    @blur="onBlur()"
    @change="onChange"
    @focus="onFocus()"
    @keypress="onKeyPress"
    @keyup="onKeyUp"
  />
</template>
<script>
  const ADDRESS_TYPES = {
    street_number: 'short_name',
    route: 'long_name',
    locality: 'long_name',
    administrative_area_level_1: 'short_name',
    administrative_area_level_2: 'county',
    country: 'long_name',
    postal_code: 'short_name'
  }

  export default {
    name: 'VueGoogleAutocomplete',
    props: {
      id: {
        type: String,
        required: true
      },
      className: String,
      placeholder: String,
      value: {
        type: Object,
        default: null
      }
    },
    data () {
      return {
        autocomplete: null,
        autocompleteValue: ''
      }
    },
    methods: {
      blur () {
        this.$refs.autocomplete.blur()
      },
      clear () {
        this.autocompleteValue = ''
      },
      focus () {
        this.$refs.autocomplete.focus()
      },
      getFormattedPlace (place) {
        const formattedPlace = {}
        place.address_components.forEach(addressComponent => {
          const addressType = addressComponent.types[0]
          if (ADDRESS_TYPES[addressType]) {
            const value = addressComponent[ADDRESS_TYPES[addressType]]
            formattedPlace[addressType] = value
          }
        })
        return formattedPlace
      },
      onBlur () {
        this.$emit('blur')
      },
      onChange () {
        this.$emit('change', this.autocompleteValue)
      },
      onFocus () {
        this.$emit('focus')
      },
      onKeyPress (event) {
        this.$emit('keypress', event)
      },
      onKeyUp (event) {
        this.$emit('keyup', event)
      },
      placeChanged () {
        const place = this.autocomplete.getPlace()

        if (!place.geometry) {
          this.$emit('noPlaceFound', place, this.id)
          return
        }

        if (place.address_components) {
          this.$emit('placeChanged', this.getFormattedPlace(place), place, this.id)
          this.$emit('input', this.getFormattedPlace(place))
          this.autocompleteValue = this.$refs.autocomplete.value
          this.onChange()
        }
      }
    },
    watch: {
      autocompleteValue (newVal, oldVal) {
        this.$emit('inputChange', {newVal, oldVal}, this.id)
      }
    },
    mounted () {
      /* eslint-disable */
      this.autocomplete = new google.maps.places.Autocomplete(this.$refs.autocomplete, {

      })
      this.autocomplete.addListener('place_changed', this.placeChanged)
      /* eslint-enable */
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/common/VueGoogleAutocomplete.vue